module.exports = __webpack_public_path__ + "static/media/ss-logo-secondary-light.2c409a19.png";